import { render, staticRenderFns } from "./PeriodField.vue?vue&type=template&id=0b4f0f0e&scoped=true&"
import script from "./PeriodField.vue?vue&type=script&lang=js&"
export * from "./PeriodField.vue?vue&type=script&lang=js&"
import style0 from "./PeriodField.vue?vue&type=style&index=0&id=0b4f0f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f0f0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDatePicker,VMenu})
